import React, { useState } from 'react';
import "../css/GuiaUso.css";
import { Button } from '@mui/material';
import imgGuiaSol from "../logos/guia_solicitar.jpg";
import imgGuiaGes from "../logos/guia_gestion.jpg";
import pdfUso from "../Utilidades/GUÍADEUSO.pdf"
import { Page, Text, View, Image, Document, StyleSheet, PDFViewer, Font, Link } from '@react-pdf/renderer';
import logoVL from "../logos/logo-mvl.png";
import BrandonNomal from "../Brandon/Brandon_reg.otf"
import BrandonBold from "../Brandon/Brandon_bld.otf"
// import { Viewer, Worker } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';

Font.register({
  family: "brandon",
  src: BrandonNomal
})

Font.register({
  family: "brandonBld",
  src: BrandonBold
})

function Cuerre(props) {

  const idDepCulMunro = props.datos.idCulMunro;


  const dataExample = {
    "status": "ok",
    "info": "El turno fue guardado exitosamente",
    "codigo": "CF23NAW3",
    "fecha": "2023-10-3",
    "hora": "12:00",
    "lugar": "Coronel Dorrego 2443",
    "nombre": "Hector Salamanca",
    "dni": "44554518",
    "entidad": null,
    "interesados": [
        {
            "dni": 26562289,
            "nombre": "Freigeiro ",
            "apellido": "Ezequiel"
        }
    ],
    "modulo": {
        "nombre": "Deportes",
        "descripcion": "-",
        "encargado": "-"
    },
    "dependencia": {
        "nombre": "Campo N°1",
        "domicilio": "Coronel Dorrego 2443"
    },
    "servicio": {
        "nombre": "Tenis (cancha N° 1)",
        "descripcion": ""
    },
    "qr": {
        "image": "iVBORw0KGgoAAAANSUhEUgAAAV4AAAFeAQMAAAD35eVZAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABmUlEQVRoge2Zy43DMAxECaQAleTWXZILMOCV+E+wp+QyAmYOsmM+50LzJ4lQFEVRv+n1uC69u+ejcZtBjrARhobtelwiCutr86cubwhhVHh51axLE06DfgIX4U3gyZ0rfs8ZsLoQ3gxWTpOvv0Z4F1jl7ta8+7RnDSEMCrtaqcwlbISB4VJl2/+shMHhlmgl6mVbCMPDikTR9CD2aqoDJWFY2P0bebc7PoYQIYwNm2tl5PxhASvR9oybMDK8nq2QPHTv5smRMZ5Jb1wJ48I+LRaiPn8i7xLGhV8eploqc+iX3Bew+CWMDYd/a+qooukJmTAyrFYf/yUy8BVDSE+5hCFh71RrZKzzKA1YwvDwmaNHplcP3fwDwshwtD0idecbAebuEmFMOJvUOExct7mLI+O9aBIGg7svPWBtebx77UWTMCBcR1HSotaQI1shwsiwXdvIaN2ru/tzeCQMCKvhY+o44isgvBNsJxfm6RHbckJ4H7jNjZmLIwMTBoZVmWh7hI56lzAu7IrTQ58WayNASoQBYYqiKOpb/QEiIGf+vusb6gAAAABJRU5ErkJggg==",
        "ruta": "http://10.100.17.102/turnera/apiTurnera/temp/2023-10-04_143601_CF23NAW3.png"
    }
};
  
  const styles = StyleSheet.create({
    page: {
      backgroundColor: 'white',
      // fontFamily: "brandon",
    },
    section: {
      margin: 10,
      padding: "0 10 0",
      flexGrow: 1,
    },
    sectionTitulo: {
      alignItems: "center",
      padding: 10,
      width: "100%",
    },
    itemTurno: {
      margin: "6 0 6",
      fontSize: 11,
      fontFamily: "brandon"
    },
    itemItem: {
      margin: "6 0 6",
      fontSize: 11,
      fontFamily: "brandonBld"
    },
    imageContainer: {
      marginTop: 10,
      marginBottom: 10,
      alignItems: 'center',
      width: "100%"
    },
    image: {
      width: 150, // Tamaño de la imagen
      height: 150, // Tamaño de la imagen
    },
    line: {
      borderBottom: 1, // Grosor de la línea
      borderColor: 'black', // Color de la línea (negro en este caso)
      margin: '0', // Margen superior e inferior para ajustar la posición de la línea
    },
    imageVl: {
      width: 180, // Tamaño de la imagen
      height: 55, // Tamaño de la imagen
    },
  });
  
  const imagenPrueba= "iVBORw0KGgoAAAANSUhEUgAAAV4AAAFeAQMAAAD35eVZAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABm0lEQVRoge2ZXY7DIAyELeUAOVKu3iNxACRa/IfZRFpp92UqzTyQlHzkZWqwHRGKoijqfzqGq33uXjn3OrvIFc8IQ8N2vZou62Ir5s/PsCGEUeHpqsHGmb+Hz83/AeGvgJfnw4wn/H2wB6ca/6vdhGFgle+xel6OnNsQwqCwK+A6xDPCwPCSBmeafD4hhDHh6Wqcl12247NnFkQYFXaTNWfV3dYGK0JOfwthYFhiLurG0gMYLYKYMC4ccWnp6tlL5a+ux1rCwPCK0N1avRBGh2Xv2IhE7uMZ7eMJSxgKHnt24+63PEM3twkDwmayP5hhekbGk2sJA8MepsXulbN6BXkQxobH+gAlVmtI2XJ/2E0YEPZOW2Sq9gJde61+DmFseJYepw+jVP521wmjwxmh02Q9OW14DFjCYPDSeho9gPJnIAwLB5Ilo0dt+Sh1fx9hKNiuNhfpqkrW8UkYGr7GGJ6ppuelgXPPkQjDwq/cY69ojUsVYXC4BGxNezphcFilfbjR1l32BQijw66W3TeJ1vhNhAFhiqIo6q96A3J3QAfkdgrrAAAAAElFTkSuQmCC";
  
  return (
    
      <Document>
        {console.log(props.dependencia)}
        <Page size={[230]} style={styles.page}>
          <View style={styles.sectionTitulo}>
            <Image src={logoVL} style={styles.imageVl} />
            {/* <Text style={styles.textoTitulo}>SISTEMA DE GESTIÓN DE TURNOS DE LA  MUNICIPALIDAD DE VICENTE LÓPEZ</Text> */}
          </View>
          <View style={styles.line}></View>
          <View style={styles.section}>
            <Text style={{...styles.itemTurno, fontSize: 13}}>{props.datos.nombre}, su reserva ha sido confirmada.</Text>
            <Text style={{color:"green", textDecoration:"underline", fontSize: 14, fontFamily: "brandonBld"}}>RESUMEN:</Text>
            <Text style={styles.itemItem}>N° de {props.dependencia==idDepCulMunro? "Reserva" : "Turno"}:
              <Text style={styles.itemTurno}> {props.datos.codigo}</Text>
            </Text>
            {/* <Text style={styles.itemItem}>DNI registrado: {props.datos.dni}</Text> */}
            {/* <Text>Área: {props.datos.servicio.nombre}</Text> */}
            <Text style={styles.itemItem}>{props.dependencia==idDepCulMunro? "Sede" : "Dependencia"}:
              <Text style={styles.itemTurno}> {props.datos.dependencia}</Text>
            </Text>
            <Text style={styles.itemItem}>
              Lugar: 
              <Text style={styles.itemTurno}> {props.datos.lugar}</Text> 
            </Text>

            <Text style={styles.itemItem}>{props.dependencia==idDepCulMunro? "Fecha de la función" : "Fecha"}:
            <Text style={styles.itemTurno}> {props.datos.fecha}</Text>
            </Text>
            <Text style={styles.itemItem}>Hora:
            <Text style={styles.itemTurno}> {props.datos.hora}</Text> 
            </Text>
            <Text style={styles.itemItem}>{props.dependencia==idDepCulMunro? "Reserva" : "Tramite"}:
            <Text style={styles.itemTurno}> {props.datos.servicio}</Text> 
            </Text>
            {/* <Text style={styles.itemItem}>{props.datos.dependencia.descripcion}</Text> */}
            {/* <Text style={styles.itemItem}>{props.datos.servicio.descripcion}</Text> */}
            <Text style={styles.itemTurno}>Hemos enviado un email a tu casilla de correo electrónico {} con los detalles de la reserva. Si desea cancelarla, puede acceder a la página: </Text>
            <Link style={{color: "blue", textDecoration: "underline", fontSize: 10}} src="https://turnos.vicentelopez.gov.ar/gestiones" >https://turnos.vicentelopez.gov.ar/gestiones</Link>
            {/* <View style={styles.imageContainer}>
              <Image src={`data:image/png;base64,${props.datos.qr[0].image}`} style={styles.image} />
            </View>
            {props.datos.qr.length > 1 &&
              <View style={styles.imageContainer}>
                <Image src={`data:image/png;base64,${props.datos.qr[1].image}`} style={styles.image} />
              </View>
            } */}
            {props.datos.qr.map((qr, index) => (
              <View key={index} style={styles.imageContainer}>
                <Image src={`data:image/png;base64,${qr.image}`} style={styles.image} />
              </View>
            ))}
          </View>
        </Page>
      </Document>
  );
}

export default Cuerre;
